export const stepsList = [
    {number: 1, text: 'Elige tu estación de servicios', key: 1},
    {number: 2, text: 'Elige la fecha de tu cambio', key: 2},
    {number: 3, text: 'Ingresa los datos de tu auto', key: 3},
    {number: 4, text: 'Ingresa tus datos', key: 4},
    {number: 5, text: 'Confirma la info y ¡listo!', key: 5},
]